<template>
    <div class="slide-bar-wrap">
        <el-menu
            router
            :default-active="$route.path"
            :collapse="isCollapse"
            class="left-menu"
            @select="handleSelectMenu"
            :background-color="$menu - bg"
            :text-color="$menu - text"
            :active-text-color="$menu - text - active"
            unique-opened="true"
        >
            <template v-for="item in menuList">
                <el-menu-item
                    v-if="!item.child"
                    :key="item.id"
                    :index="item.url"
                >
                    <i :class="[item.icon, 'iconfont']"></i>
                    <span slot="title">{{ item.name }}</span>
                </el-menu-item>
                <el-submenu v-else :key="item.id" :index="item.id">
                    <template slot="title">
                        <i :class="item.icon"></i>
                        <span>{{ item.name }}</span>
                    </template>
                    <template v-for="second in item.child">
                        <el-menu-item
                            ref
                            v-if="!second.child"
                            :key="second.id"
                            :index="second.url"
                            >{{ second.name }}</el-menu-item
                        >
                        <el-submenu v-else :key="second.id" :index="second.url">
                            <template slot="title">{{ second.name }}</template>
                            <el-menu-item
                                :index="third.url"
                                v-for="third in second"
                                :key="third.id"
                                >{{ third.name }}</el-menu-item
                            >
                        </el-submenu>
                    </template>
                </el-submenu>
            </template>
        </el-menu>
    </div>
</template>
<script>
export default {
    computed: {
        menuList() {
            return this.$store.state.login.menuList;
        },
        isCollapse() {
            return this.$store.state.index.isCollapse;
        }
    },
    methods: {
        /**
         * 收起还是展开
         */
        handleChangeCollapse() {
            this.isCollapse = !this.isCollapse;
            this.$store.commit("INDEX_COLLAPSE", this.isCollapse);
        },
        handleSelectMenu(index, indexPath) {
            if (event.ctrlKey) {
                let routeData = this.$router.resolve({
                    path: index
                });
                this.$nextTick(() => {
                    window.open(routeData.href);
                });
            }
            for (let i in this.menuList) {
                if (indexPath[0] == this.menuList[i].id) {
                    for (let j in this.menuList[i].child) {
                        if (index == this.menuList[i].child[j].url) {
                            this.$store.state.menu.menu_id = this.menuList[
                                i
                            ].child[j].id;
                            localStorage.setItem(
                                "menu_id",
                                this.$store.state.menu.menu_id
                            );
                            localStorage.setItem(
                                "activeTabLabel",
                                this.menuList[i].child[j].name
                            );
                            this.$store.dispatch("getMenuAuth");
                        }
                    }
                }
                // 首页
                if (this.menuList[i].url == "/home") {
                    localStorage.setItem(
                        "activeTabLabel",
                        this.menuList[i].name
                    );
                }
            }
        }
    }
};
</script>
<style lang="scss">
// .el-tabs--card {
//     margin: -21px -20px 0 -20px;
// }
.left-menu {
    width: 200px;
}
.el-menu--collapse {
    width: 64px;
}
.el-menu-item,
.el-submenu__title {
    text-align: left;
    height: 48px;
    line-height: 48px;
    i {
        padding-right: 10px;
    }
}
.el-submenu {
    text-align: left;
    .el-menu-item {
        height: 48px;
        line-height: 48px;
        font-size: 12px;
        padding-left: 55px !important;
    }
    .is-active {
        position: relative;
        &:after {
            position: absolute;
            content: "";
            width: 4px;
            height: 100%;
            background: $theme-color;
            left: 0;
            top: 0;
        }
    }
}
.el-icon-sell {
    width: 16px !important;
    height: 16px !important;
    margin: 0 !important;
}
</style>
